export default "__VITE_ASSET__8e7b08c7__"